"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const urls_1 = __importDefault(require("./urls"));
class ChargebeeClient {
    generateChargebeePortal() {
        return __awaiter(this, void 0, void 0, function* () {
            const { portal_session: portalSession } = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.generateChargebeePortal(),
                // redirect_url must use HTTPS and port 443, 80, 8443, or 8080
                // to test this in development try `HTTPS=true PORT=8080 yarn start`
                body: { redirect_url: window.location.href },
            });
            return portalSession;
        });
    }
}
exports.default = ChargebeeClient;
